import Vue from 'vue'
import ResizeObserver from 'resize-observer-polyfill'

Vue.directive('resize', {
  bind(el, binding) {
    el.__observer__ = new ResizeObserver(binding.value)
    el.__observer__.observe(el)
  },
  unbind(el) {
    if (el.__observer__) {
      el.__observer__.unobserve(el)
      el.__observer__ = null
    }
  }
})
